<div class="input-group">
    <input class="form-control {{inputClass}}" [ngClass]="{'is-invalid': this.invalid, 'is-valid': !this.invalid && showValidClass}"
        [placeholder]="placeholder" ngbDatepicker #ngbDateFrom="ngbDatepicker" autocomplete="off" [(ngModel)]="ngDate"
        (ngModelChange)="modelChanged($event)" [disabled]="isDisabled">
    <div class="input-group-append">
        <button class="btn btn-outline-secondary calendar" (click)="ngbDateFrom.toggle()" type="button">
            <i class="fas fa-calendar-alt"></i>
        </button>
    </div>
    <input type="hidden">
</div>

<!-- {{invalid && wrongDateBehavior == 'invalid' ? invalidClass : ''}}
{{!invalid && wrongDateBehavior == 'invalid' ? successClass : ''}} -->